<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .toggle-container {
    display: flex;
    align-items: center;
  }

  .tooltip {
    display: flex;
    flex-wrap: wrap;
    max-width: utils.in_rem(200px);
  }
</style>

<script>
  import TextToggle from "@sourcewhale/shared/svelte-design-system/components/atoms/Toggles/TextToggle.svelte";
  import { integrationStore } from "../../stores";

  export let type; // optional, required for advanced section
  export let setting; // the setting object to render
  export let disableTransition = false; // optional, disables transitions

  // When type changes and disableTransition is true, temporarily disable transitions
  let noTransition = false;
  $: if (type && disableTransition) {
    noTransition = true;
    setTimeout(() => {
      noTransition = false;
    }, 50);
  }

  const handleToggle = (newValue) => {
    $integrationStore.setValue(setting.key, newValue, type);
  };
</script>

{#if noTransition}
  <style>
    .slider,
    .slider::before {
      transition: none !important;
    }
  </style>
{/if}

<div class="toggle-container">
  <TextToggle
    checked={$integrationStore.getValue(setting.key, type)}
    onToggle={handleToggle}
    label={setting.title}
    tooltip={!!setting.info}
  >
    <span slot="tooltip" class="tooltip">
      {setting.info}
    </span>
  </TextToggle>
</div>
